import React from "react";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-background text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 flex items-center justify-center mb-4 font-bold text-2xl">
            ⚠️
          </div>
          <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
            Something went wrong loading this page
          </h2>
          <p className="text-sm text-muted-foreground max-w-md mb-6 leading-relaxed">
            {this.state.error?.message || "An unexpected error occurred while rendering."}
          </p>
          <div className="flex gap-3">
            <Button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6"
            >
              🔄 Refresh Page
            </Button>
            <Button
              variant="outline"
              onClick={() => (window.location.href = "/app")}
              className="rounded-full px-6"
            >
              Go to App Home
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
